import { Alert } from "@mui/material";

const AlertMessage = ({ type = "info", message }) => {
  if (!message) return null;

  return (
    <>
    {message && 
    <Alert
      severity={type} // 'success' | 'error' | 'warning' | 'info'
      sx={{ my: 3 }}
    >
      {message}
    </Alert>
    }
    </>
  );
};

export default AlertMessage;
